import { render } from "./cross.svg?vue&type=template&id=61f4ec20"
const script = {}

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__